import type { IconNode } from '../types';

/**
 * @name hockey-stick
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgNHY0YzAgMS4xLTIuMDI1IDItNC41IDJTMiA5LjEgMiA4VjQiIC8+CiAgPHBhdGggZD0iTTE4LjIxIDMuMTA2YTIgMiAwIDAxMy41NzkgMS43ODlsLTYuODk1IDEzLjc4OUE2IDYgMCAwMTkuNTI5IDIySDQuNWExIDEgMCAwMTAtNWg1LjUyOGEyIDIgMCAwMDEuNzg4LTEuMTA1eiIgLz4KICA8cGF0aCBkPSJtMTguNTkgMTEuMjk1LTMuNTc4LTEuNzg5IiAvPgogIDxwYXRoIGQ9Im0yMC43OSA2Ljg5NS0zLjU3OC0xLjc4OSIgLz4KICA8cGF0aCBkPSJNNyAxN3Y1IiAvPgogIDxlbGxpcHNlIGN4PSI2LjUiIGN5PSI0IiByeD0iNC41IiByeT0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/hockey-stick
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const HockeyStick: IconNode = [
  ['path', { d: 'M11 4v4c0 1.1-2.025 2-4.5 2S2 9.1 2 8V4' }],
  [
    'path',
    {
      d: 'M18.21 3.106a2 2 0 013.579 1.789l-6.895 13.789A6 6 0 019.529 22H4.5a1 1 0 010-5h5.528a2 2 0 001.788-1.105z',
    },
  ],
  ['path', { d: 'm18.59 11.295-3.578-1.789' }],
  ['path', { d: 'm20.79 6.895-3.578-1.789' }],
  ['path', { d: 'M7 17v5' }],
  ['ellipse', { cx: '6.5', cy: '4', rx: '4.5', ry: '2' }],
];

export default HockeyStick;
